import PouringAnimation from 'components/PouringAnimation/PouringAnimation';
import './SuspenseLoader.scss';

const SuspenseLoader = () => {
  return (
    <div className="suspense-loader">
      <div className="suspense-loader__animation">
        <PouringAnimation />
      </div>
    </div>
  );
};

export default SuspenseLoader;
